import React, {useEffect, useCallback} from 'react';
import {useParams} from 'react-router-dom';
import filter from 'lodash/filter';
import toString from 'lodash/toString';
import find from 'lodash/find';
import without from 'lodash/without';
import dropWhile from 'lodash/dropWhile';
import takeWhile from 'lodash/takeWhile';
import remove from 'lodash/remove';
import get from 'lodash/get';
import map from 'lodash/map';
import CategoryProfileList from '../../components/CategoryProfileList';
import {
    fetchUserGalleryRequested,
    fetchUserPhotoSaveRequested,
    fetchUserPhotoUploadRequested,
    fetchUserRequested
} from '../../store/users/actions';
import {useDispatch, useSelector} from 'react-redux';
import 'react-image-lightbox/style.css';
import {useDropzone} from 'react-dropzone'
import PhotoBox from "../../components/PhotoBox";

export default function UserDetailPage() {
    const dispatch = useDispatch();
    const {id} = useParams();
    const {user, photos, photosDefaultState} = useSelector(state => state.users);
    const photosSelect = find(photos, {isSelected: true})
    const onDrop = useCallback(acceptedFiles => {
        // Do something with the files
        map(acceptedFiles,(myFile) =>{
            // const myFile = acceptedFiles[0];
            const reader = new FileReader();
            reader.readAsDataURL(myFile);
            reader.onload = function () {
                const base64result = reader.result.split(';base64,')[1]
                dispatch(fetchUserPhotoUploadRequested({user_id: id, filename: myFile.name, photo: base64result}))
            };
        })

    }, [])
    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})

    useEffect(() => {
        dispatch(fetchUserRequested({id}));
        dispatch(fetchUserGalleryRequested({id}));
    }, []);

    const countBySkillFromRecommendations = (skill, recommendations) => {
        const foundRecommendation = recommendations.find((eachRecommendation) => eachRecommendation.skill.id === skill.id);
        if (foundRecommendation !== undefined) {
            return foundRecommendation.count;
        } else {
            return 0;
        }
    };

    const closeRecommendations = filter(get(user, 'recommendations', []), (eachRecommendation) =>
        find(user.skills, (eachEditingSkill) => eachRecommendation.skill.id === eachEditingSkill.id) === undefined
    );

    const closeTr = (eachRecommendation) => (`${eachRecommendation.skill.name} (${eachRecommendation.count})`);
    const openTr = (eachSkill) => (`${eachSkill.name} (${countBySkillFromRecommendations(eachSkill, user.recommendations)})`);

    return (
        <div style={{width: '100%'}}>
            {
                user ? (
                    <div className="row">
                        <div className="col-4">
                            <div className="card">
                                <div className="card-header">Профиль пользователя id {user.id}</div>
                                <div className="card-body">
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item">Имя и фамилия:
                                            <span>{user.display_name}</span>
                                        </li>
                                        <li className="list-group-item">Телефон:
                                            <span>{user.phone_number}</span>
                                        </li>
                                        <li className="list-group-item">Instagram:
                                            <span>{user.instagram_account}</span>
                                        </li>
                                        <li className="list-group-item">Vk:
                                            <span>{user.vk_account}</span>
                                        </li>
                                        <li className="list-group-item">Facebook:
                                            <span>{user.facebook_account}</span>
                                        </li>
                                        <li className="list-group-item">Описание:
                                            <span>{user.description}</span>
                                        </li>
                                        <li className="list-group-item">Внутренний комментарий::
                                            <span>{user.internal_description}</span>
                                        </li>
                                    </ul>
                                </div>

                            </div>
                        </div>

                        <div className="col-4">
                            <CategoryProfileList
                                title={'Открытые категории'}
                                user={user}
                                skillTr={openTr}
                                dataArray={user.skills}
                            />

                        </div>
                        <div className="col-4">
                            <CategoryProfileList
                                title={'Не открытые категории'}
                                user={user}
                                skillTr={closeTr}
                                dataArray={closeRecommendations}
                            />
                        </div>
                        <div className="col-8">
                            <div className="card">
                                <div className="card-header">
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        {
                                            isDragActive ?
                                                <button className="btn btn-success btn-sm">Добавить
                                                    Изображение</button> :
                                                <button className="btn btn-success btn-sm">Перетащите сюда несколько
                                                    файл или щелкните, чтобы выбрать файл</button>
                                        }
                                    </div>
                                </div>
                                <div className="card-body">
                                    <PhotoBox images={photos}/>

                                </div>
                                <div className="card-footer">
                                    <div className="btn-group btn-group-sm">
                                        {photosSelect &&
                                        <button type="button" className="btn btn-danger"
                                                onClick={() => {
                                                    // const selectedPhotos = without(photos,(photo)=>(photo.isSelected))
                                                    // const photos_ids = remove(photos,(photo) => Boolean(!photo.isSelected))
                                                    const photos_ids = []
                                                    map(photos,(photo)=> {!photo.isSelected && photos_ids.push(photo.id)})
                                                    dispatch(fetchUserPhotoSaveRequested({
                                                            user_id: id,
                                                            photos_ids
                                                        }
                                                    ))
                                                }}
                                        >Удалить</button>}
                                        {!photosDefaultState &&
                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={() => {
                                                const photos_ids = map(photos,(photo) => toString(photo.id))
                                                dispatch(fetchUserPhotoSaveRequested({
                                                        user_id: id,
                                                        photos_ids
                                                    }
                                                ))
                                            }}
                                        >Сохоанить</button>}
                                        {!photosDefaultState &&
                                        <button
                                            type="button"
                                            className="btn btn-warning"
                                            onClick={() => {
                                                dispatch(fetchUserGalleryRequested({id}))
                                            }}
                                        >Отменить</button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="alert alert-danger">
                        <strong>Ошибка!</strong> пользователь не найден
                    </div>
                )
            }
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/pages/UserDetailPage/index.jsx